import styled from "styled-components";

export const FinalMeme = styled.img`
  max-width: 350px;
  max-height: 500px;
  height: auto;
  box-shadow: 3px 2px 10px 0px rgba(0, 0, 0, 0.75);
  margin-bottom: 1.5rem;
`;
